import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with credentials
const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// API Service
const apiService = {
  // Quote submissions
  submitDeliveryQuote: async (data) => {
    const response = await api.post('/api/quotes/delivery', data);
    return response.data;
  },

  submitMiniMoveQuote: async (data) => {
    const response = await api.post('/api/quotes/mini-move', data);
    return response.data;
  },

  submitBusinessApplication: async (data) => {
    const response = await api.post('/api/quotes/business', data);
    return response.data;
  },

  // Contact form
  submitContactForm: async (data) => {
    const response = await api.post('/api/contact', data);
    return response.data;
  },

  // Support tickets
  submitSupportTicket: async (data) => {
    const response = await api.post('/api/support', data);
    return response.data;
  },

  // Tracking
  trackBooking: async (bookingRef) => {
    const response = await api.get(`/api/track/${bookingRef}`);
    return response.data;
  },

  // Admin - Leads
  getAdminLeads: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await api.get(`/api/admin/leads${params ? `?${params}` : ''}`);
    return response.data;
  },

  getAdminStats: async () => {
    const response = await api.get('/api/admin/stats');
    return response.data;
  },

  updateLeadStatus: async (leadType, leadId, status) => {
    const response = await api.put(`/api/admin/leads/${leadType}/${leadId}/status`, { status });
    return response.data;
  },

  // Admin - Booking Updates
  updateBookingStatus: async (bookingRef, status) => {
    const response = await api.put(`/api/admin/bookings/${bookingRef}/status`, { status });
    return response.data;
  },

  addTrackingUpdate: async (bookingRef, message, location = null) => {
    const response = await api.post(`/api/admin/bookings/${bookingRef}/update`, { message, location });
    return response.data;
  }
};

// Export both the configured axios instance and the service
export { api as default, apiService };
